var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 194,
    viewBox: "0 0 245 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.979 48.7277C56.275 63.3747 15.359 126.459 0.0600196 191.592C-0.429193 193.64 2.19477 194.886 3.48451 193.239C36.751 150.901 82.1144 130.822 145.045 129.798C147.936 129.754 150.293 132.113 150.293 135.007V174.006C150.293 178.637 155.897 180.952 159.143 177.702L243.466 93.2921C245.511 91.2441 245.511 87.9497 243.466 85.9463L159.188 1.53673C155.897 -1.75774 150.337 0.601812 150.337 5.23187V43.6525C150.337 46.1901 148.469 48.327 145.979 48.7277Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.5a59668a51d035185748fd4157ee961a.svg";
export { ForwardRef as ReactComponent };